<template>
    <Modal v-model="planImportModel.show" title="请选择要导入的文件" :mask-closable="false" @on-ok="onImportPlan"
        :loading="true" width=300>
        <div style="display:flex;justify-content: space-between;">
            <Upload :show-upload-list="false" :action="UPLOAD_FILE_API" :format="['xlsx']"
                :on-success="handleSuccess" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>

            <Button icon="ios-cloud-download-outline" @click="downloadImportTemplate()">下载模板</Button>
        </div>
        <div>{{planImportModel.fileName}}</div>
    </Modal>
</template>
<script>
import {
    DOWNLOAD_SERVER,
    UPLOAD_FILE_API
} from '@/api/modules/files';
export default {
    data() {
        return {
            UPLOAD_FILE_API,
            planImportModel: {
                show: false,
                loading: false,
                fileWebName: '',
                fileName: ''
            }
        };
    },
    methods: {
        onImportPlan() {
            importPreSalePlan({
                importFileName: this.planImportModel.fileWebName
            }).then(res => {
                this.planImportModel.show = false;
                if (res.code === 0) {
                    this.getPlanWeeks();
                    this.$Modal.success({
                        title: '导入成功',
                        content: ''
                    });
                }
            });
        },
        downloadImportTemplate() {
            let url = DOWNLOAD_SERVER + 'Import/template/plan_import_template.xlsx';
            this.$downLoadFile(url);
        },
        handleFormatError(file) {
            const str = this.format.join(', ');
            this.$Notice.warning({
                title: '文件格式错误',
                desc: '请选择 ' + str + ' 后缀的文件.'
            });
        },
        handleSuccess(res, file) {
            this.planImportModel.fileWebName = res.data.fileList[0].fileUuid;
            this.planImportModel.fileName = res.data.fileList[0].fileName;
        }
    }
};

</script>